import { GeneratePushID } from './GeneratePushID.js';

/**
 * Gets the default (empty) value for a new attribute
 * @param {string} attributeName - The name (key) of the attribute
 * @param {object} otherAttributes - The attributes configuration object from models
 * @param {object} [options]
 * @param {boolean} [options.formatTableAttributes] - If true, returns table attributes as an object containing a single blank "row" object
 * @returns {any} The default value for the attribute
 */
export function GetNewAttributeValue(attributeName, otherAttributes, options = {}) {
  const attributeConfig = otherAttributes?.[attributeName];
  const guiElement = attributeConfig?.gui_element;
  switch (guiElement) {
    case 'table':
      if (options.formatTableAttributes) {
        return {
          [GeneratePushID()]: Object.fromEntries(
            attributeConfig.table_items?.map((item) => [
              item.attribute,
              item.value ?? GetNewAttributeValue(item.attribute, otherAttributes)
            ]) ?? []
          )
        };
      }
      // TODO (2024-03-20): The above code is probably the correct implementation, but we need to have a conversation about how
      // to handle table attributes (we may have implemented them incorrectly to begin with; job-level uses look the same as node-level uses)
      return Object.fromEntries(attributeConfig.table_items?.map((item) => [item.attribute, item.value || '']) ?? []);
    case 'multi_dropdown':
      return { '-k000': '' };
    case 'pole_tag':
      return {
        owner: false,
        tagtext: '',
        company: ''
      };
    case 'cost-causer':
      return {
        cost: '',
        explanation: '',
        companies: {
          [GeneratePushID()]: { company: '', percentage: '' }
        }
      };
    case 'loading-data':
      return {
        loadingAnalysis: '',
        loadingResult: '',
        loadingPercentage: '',
        loadingNotes: '',
        chartData: {}
      };
    case 'checkbox':
      return false;
    case 'laser_data':
      return {
        measurement: '',
        laserData: {}
      };
    case 'instantiateLaserTable':
      return {
        instantiated: false
      };
    case 'power_consumption':
      return {
        kva: 0,
        note: '',
        unknown: false
      };
    default:
      return '';
  }
}
